
import React from 'react';
import { Check } from 'lucide-react';

interface RegistrationSuccessHeaderProps {
  username: string;
}

const RegistrationSuccessHeader = ({ username }: RegistrationSuccessHeaderProps) => {
  return (
    <div className="text-center space-y-4">
      <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto">
        <Check className="w-8 h-8 text-white" />
      </div>
      <h1 className="text-3xl font-bold text-sports-green">
        Account Created Successfully!
      </h1>
      <p className="text-gray-300 text-lg">
        Your secure account for <span className="text-sports-green font-semibold">{username}</span> has been created.
      </p>
    </div>
  );
};

export default RegistrationSuccessHeader;
